export default "/assets/webpack-assets/GT-Walsheim-Pro-Bold-Oblique.45f39f36cc73941d5bf8fe77e0c0341b.woff";